import * as React from 'react';

import * as styles from './ProjectPrice.css';

export interface IProjectPriceProps {
  start: string;
}

export const ProjectPrice: React.FC<IProjectPriceProps> = ({ start }) => {
  return (
    <div className={styles['container']}>
      <span>{start}</span>
    </div>
  );
};
